import { useEventListener } from '@24i/player-utils-react';
import { isPlatformWeb } from '@24i/nxg-core-utils';
const useEventsManager = ({ onPlay, onPause, onSeeking, onSeekingOutOfDVR, onSeeked, onDurationChange, onAdBreakEnd, onAdBreakStart, onEnd, onBitrateChange, }, playerInstance) => {
    useEventListener('playing', isPlatformWeb ? onPlay : null, playerInstance);
    useEventListener('play', onPlay, playerInstance);
    useEventListener('pause', onPause, playerInstance);
    useEventListener('seeking', onSeeking, playerInstance);
    useEventListener('seekingoutofdvr', onSeekingOutOfDVR, playerInstance);
    useEventListener('seeked', onSeeked, playerInstance);
    useEventListener('durationchange', onDurationChange, playerInstance);
    useEventListener('adbreakstarted', onAdBreakStart, playerInstance);
    useEventListener('adbreakended', onAdBreakEnd, playerInstance);
    useEventListener('ended', onEnd, playerInstance);
    useEventListener('bitratechange', onBitrateChange, playerInstance);
};
export { useEventsManager };
//# sourceMappingURL=events.js.map